module.exports = __webpack_public_path__ + "static/img/医疗.ee417d76.png";